import { render, staticRenderFns } from "./create-region.vue?vue&type=template&id=3e3bbf4a&"
import script from "./create-region.vue?vue&type=script&lang=js&"
export * from "./create-region.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports